import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/manufacturers.scss';

initMainHeader();
